var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchAppCenterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.07794 9.04514C2.62904 10.3419 3.6727 11.3666 4.97933 11.8938C6.28595 12.4211 7.74851 12.4077 9.04526 11.8566C10.342 11.3055 11.3667 10.2618 11.894 8.9552C12.4212 7.64857 12.4078 6.18601 11.8567 4.88927C11.3056 3.59252 10.2619 2.56781 8.95531 2.04057C7.64869 1.51332 6.18613 1.52672 4.88938 2.07782C3.59264 2.62893 2.56793 3.67259 2.04068 4.97921C1.51343 6.28584 1.52683 7.7484 2.07794 9.04514V9.04514Z",
    stroke: "#A8B2C8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0293 10.874L14.9999 14.8446",
    stroke: "#A8B2C8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchAppCenterIcon);
export default __webpack_public_path__ + "static/media/search-app-center-icon.f94506fa0d48bd3f02df296ca0dd7150.svg";
export { ForwardRef as ReactComponent };